import { useState, useEffect, Fragment } from 'react';
import { useTranslation } from 'react-i18next'
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Loader from '../../../components/Loader/Loader';
// import PaymentSetup from './PaymentSetup';
import PaymentMethods from '../../../components/subscription/payment-methods/PaymentMethods';
import PaymentMethodsItem from '../../../components/subscription/payment-methods/PaymentMethodsItem';

import { useStore } from '../../../hook-store/store';
import { 
  cardExpire,
  getCustomerCardPaymentMethods,
  // updateSubscriptionDefaultPaymentMethod,
  // detachPaymentMethod,
 } from '../../../utils/stripe/payment-method-utils';

 import { BACKEND_URL } from '../../../App'
// import classes from './PaymentMethods.module.css';

function PaymentMethod(props) {
  const {
    // subscriptionId,
    // isSubscribe,
  } = props;
  
  const [t] = useTranslation('translation');
  const location = useLocation();
  const navigate = useNavigate();

  const [store, dispatch] = useStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    customerMethods,
    subscriptions,
  } = store.stripeData;
  const { gLoading } = store.uiStore;

  const [isLoading, setIsLoading] = useState(false);
  const [modifiedMethods, setModifiedMethods] = useState([]);
  // const [showPaymentSetup, setShowPaymentSetup] = useState(false);
  // const [selectedId, setSelectedId] = useState('');
  // const [showConfirmDetach, setShowConfirmDetach] = useState(false);
  
  const subscriptionId = location.state.subscriptionId;

  if (!subscriptionId) {
    navigate('/subscription/account');
  }
  // if (!subscriptionId) {
  //   const activeSubscription = subscriptions.find(ele => {
  //     return ele.status === 'active';
  //   });

  //   if (activeSubscription) {
  //     subscriptionId = activeSubscription.id;
  //   }
  // }



  let paymentMethodBody = (
    <div>
      <PaymentMethods 
        subscriptionId={subscriptionId}
      />
      {/* No payment method, please add new one */}
    </div>
  );


  // if (modifiedMethods.length >= 0) {
  //   paymentMethodsBody = (
  //     <div>
  //       <div 
  //       // className={classes.paymentMethodsRow}
  //       >
  //         <span 
  //         // className={classes.paymentMethodsTitle}
  //         >
  //           Payment methods
  //         </span>
  //       </div>
  //       <div>
  //         {isLoading && (
  //           <Loader />
  //         )}
  //       </div>
  //       <ul 
  //       // className={classes.paymentMethodsRow}
  //       >
  //         {modifiedMethods.map(method => {
  //           // const cardInfo = method.card;
  //           // const cardExpired = cardExpire(method.card.exp_month, method.card.exp_year);
            
  //           // // const isSubscriptionMethod = method.id === usageBasedSubscription.default_payment_method;

  //           return (
  //             <li key={method.id}>
  //               <PaymentMethodsItem
  //                 method={method}
  //                 subscriptionId={subscriptionId}
  //                 isSubscribe={isSubscribe}
  //               />
  //             </li>
  //           );
  //         })}
  //       </ul>
  //     </div>
  //   );
  // }
 

  return (
    <Fragment>
      <div>
        {paymentMethodBody}
      </div>
    </Fragment>
  );
}

export default PaymentMethod;
